import { FC } from 'react';
import { Box, Flex, Text } from '@thebouqs/ui';
import useTranslation from '@/hooks/useTranslation';
import useUser from '@/hooks/useUser';
import { CartItems } from '@/interfaces';

interface VaseDisplayProps {
  item: CartItems;
  localCartProducts: {
    create_subscription?: boolean;
  };
  handleRemoveVaseItem: (
    id: string,
    options: { delivery_date: string; addon_id: string }
  ) => void;
}

const VaseDisplay: FC<VaseDisplayProps> = ({
  item,
  localCartProducts,
  handleRemoveVaseItem,
}) => {
  const { t } = useTranslation();
  const { is_subscriber, subscription_activation_used } = useUser();

  const formatPrice = (price: string | number) => {
    const num = parseFloat(price as string);
    if (Number.isInteger(num)) {
      return num.toString();
    }
    return num.toFixed(2);
  };

  return (
    <Flex padding="1.15em 0" borderTop="1px solid #E2E8F0">
      <Box
        key="gallery-preview-item-"
        width="3.6rem"
        height="3.6rem"
        flexBasis="3.6rem">
        <img
          src={item.vase?.image}
          alt="cart-image"
          data-testid={`cart-image`}
          style={{
            borderRadius: '50%',
            width: '3.6rem',
            height: '3.6rem',
            objectFit: 'cover',
          }}
        />
      </Box>
      <Flex flexDirection="column" marginLeft="1.15em">
        <Text marginBottom=".25em">{item.vase.name}</Text>
        <Flex>
          {!is_subscriber && subscription_activation_used ? (
            <Text marginBottom=".25em" color="#333333" fontWeight="600">
              ${formatPrice(item.vase.price)}
            </Text>
          ) : localCartProducts?.create_subscription ? (
            <>
              <Text marginBottom=".25em" color="#085b45" fontWeight="800">
                ${formatPrice(item.vase.discount_price)}
              </Text>
              <Text
                marginBottom=".25em"
                marginLeft=".35em"
                style={{
                  color: '#999999',
                  fontWeight: '400',
                  textDecoration: 'line-through',
                  textDecorationThickness: '1px',
                }}>
                ${formatPrice(item.vase.price)}
              </Text>
            </>
          ) : (
            <Text marginBottom=".25em" color="#333333" fontWeight="600">
              ${formatPrice(item.vase.price)}
            </Text>
          )}
        </Flex>
      </Flex>
      <Flex alignItems="flex-end" justifyContent="flex-end" marginLeft="auto">
        <Text
          display="flex"
          alignItems="flex-end"
          justifyContent="flex-end"
          width="100%"
          color="#144b3c"
          cursor="pointer"
          padding="0.5em 0.7em"
          letterSpacing=" 0.1em"
          fontWeight="600"
          lineHeight="1.25em"
          fontSize="0.85rem"
          textTransform="uppercase"
          onClick={() => {
            const requestData = {
              delivery_date: item.delivery_date,
              // Only include addon_id if there's currently an addon selected
              ...(item.addon_selected?.id && {
                addon_id: item.addon_selected.id,
              }),
            };
            handleRemoveVaseItem(item.id, requestData);
          }}>
          {t('pdp.removeOptionTitle')}
        </Text>
      </Flex>
    </Flex>
  );
};

export default VaseDisplay;
